import React from 'react';

import {CheckboxInputProps} from 'ui-library/inputs/CheckboxInput';

import {ClientSchemaMapperConfig} from './FlowchartConfigConstants';

export function doSchemaMapperConfigsUseConditionalMapping(
  schemaMapperConfigs: Array<ClientSchemaMapperConfig>
): boolean {
  return schemaMapperConfigs.some(
    (config) =>
      config.mapperConfig?.schemaFieldMapperConfigs.some(
        (fieldMapperConfig) => fieldMapperConfig.resultMustBeNonNullToMap
      ) ?? false
  );
}

export function getConditionalMappingCheckboxProps({
  isLocked,
  isChecked,
}: {
  isLocked?: boolean;
  isChecked: boolean;
}): Pick<CheckboxInputProps, 'disabled' | 'helpText'> {
  // We do not support adding new conditional mappings to a flowchart.
  // So if a flowchart has conditional mapping configured, we allow users to toggle the checkbox "off", but
  // we do not enable toggling it "on".
  return {
    disabled: isLocked || !isChecked,
    helpText:
      !isLocked && !isChecked ? (
        <>
          "Required field to map" is no longer supported. To customize logic and control task mappings in your
          workflow, configure a{' '}
          <a
            href="https://help.benchling.com/hc/en-us/articles/15416582358925-Configure-routers-within-a-flowchart"
            target="_blank"
            rel="noreferrer"
          >
            router
          </a>
          .
        </>
      ) : undefined,
  };
}
